import { render, staticRenderFns } from "./TopicBlock.vue?vue&type=template&id=64687906&lang=pug"
import script from "./TopicBlock.vue?vue&type=script&lang=ts"
export * from "./TopicBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports